import { createRetrievalBasicInformation } from "./createRetrievalBasicInformation";

export default createRetrievalBasicInformation("va");
